import type { FeatureManifest } from '../registry.js';
import { roundsWaiting } from './local.js';
import { EventsIcon, eventsBadge, eventsStale } from './rail.js';

/**
 * LO-01 weekly events hub (SCR-13; also shows the CP-03 Rush card): the live event from
 * remote config (theme, levels, milestones, leaderboard, start and end), coming soon, and the
 * last event's results. The rail entry carries the time left. Once a session the map hook
 * sends rounds kept offline, refreshes the live list and downloads a background art pack; it
 * opens nothing.
 */
export default {
  id: 'events',
  flag: 'events',
  unlock: 'events',
  online: true,
  provides: ['events', 'eventLeaderboard'],
  entry: { order: 4, icon: EventsIcon, label: 'feature.events.rail', testId: 'rail-events', open: 'events', badge: eventsBadge },
  mapOrder: 45,
  mapDue: (a) => a.services.sync.status !== 'offline' && !a.session.checked.has('events') && (eventsStale(a) || roundsWaiting(a)),
  load: () => import('./index.js'),
} satisfies FeatureManifest;
